import { Space } from 'antd';
import React, { FC } from 'react';
import SailingPlanApplyIcon from '@/assets/images/header/sailing-plan-apply.react.svg?react';
import SailingPlanTextIcon from '@/assets/images/header/sailing-plan-text.react.svg?react';
import SailingPlanTitleIcon from '@/assets/images/header/sailing-plan-title.react.svg?react';
import { BASE_NAME } from '@/infrastructure/history';
import styles from './index.module.scss';

export const SailingPlan: FC = () => <div className={styles.sailingPlan}>
  <Space size={'large'}>
    <SailingPlanTitleIcon/>
    <SailingPlanTextIcon/>
    <div onClick={() => window.open(`${location.origin}${BASE_NAME}/trial-apply`)} className={styles.sailingPlanApply}>
     <SailingPlanApplyIcon />
    </div>
  </Space>
</div>;
